import { useDrop } from 'react-dnd'
import { useSessionPermission } from '@btime/react-session'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useSetPlaceAvailabilityStatus } from '../_actions/_requests/setAvailabilityStatus'
import AvailabilityCard, { CARD_DND_TYPE } from './AvailabilityCard'
import AvailabilityStatusTag from '../_shared/AvailabilityStatusTag'
import { Grid } from '../../../packages/kiti/components/structure/Grid'
import Panel from '../../../packages/kiti/components/structure/Panel'
import Scroll from '../../../packages/kiti/components/helpers/Scroll'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import { Text } from '../../../components/presentation/Text'

const AvailabilityColumn = ({ status, items }) => {
  const { t } = useTranslation('availability')
  const canEdit = useSessionPermission('editPlaceAvailabilityStatus')
  const [request] = useSetPlaceAvailabilityStatus()

  // Dropping a card into the other column changes its status the same way the
  // "Alterar status manualmente" button does, and is gated by the very same
  // permission: without it, the drop is simply not accepted.
  const [{ isOver, canDrop }, dropRef] = useDrop({
    accept: CARD_DND_TYPE,
    canDrop: () => canEdit,
    drop: item => request({ placeId: item.id, status }),
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop()
    })
  })

  const bgColor = isOver && canDrop ? 'light2' : 'light1'

  return (
    <div ref={dropRef}>
      <Panel flex={1} bgColor={bgColor} noPadding minHeight="60vh">
        <Separator weight={2} paddingH={0.8} bgColor="white" usePadding>
          <Grid gap={0.4} align="center">
            <AvailabilityStatusTag status={status} />
            <Text bold color="dark3">
              ({items.length})
            </Text>
          </Grid>
        </Separator>

        <Separator weight={3} noMarginBottom flex={1}>
          <Scroll maxHeight="70vh" scrollY>
            <Grid direction="column" gap={0.6}>
              {items.map(item => (
                <AvailabilityCard key={item.id} item={item} />
              ))}
            </Grid>
          </Scroll>
        </Separator>
      </Panel>
    </div>
  )
}

export default AvailabilityColumn
